import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import Moment from 'react-moment';
import VisIcon from '../../../images/submenu_open copy 6.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Anleggsprojeksjonsflate extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleAnleggsprojeksjonsflate = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    showAnleggsprojeksjonsflate = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowAnleggsprojeksjonsflate,
                anleggsprojeksjonsflate: this.props.anleggsprojeksjonsflate
            }
        })
    }

    render() {
        const { t } = this.props
        var anleggsprojeksjonsflate = this.props.anleggsprojeksjonsflate
        var title = `${t('teig')} (${anleggsprojeksjonsflate.lagretBeregnetAreal})`        
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleAnleggsprojeksjonsflate}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{title}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.showAnleggsprojeksjonsflate}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.anleggsprojeksjonsflate')}</div>
                    </div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('lagretberegnetareal')}</div>
                            <div className="value">{anleggsprojeksjonsflate.lagretBeregnetAreal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('datafangstdato')}</div>
                            <div className="value"><Moment local>{anleggsprojeksjonsflate.datafangstdato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('medium')}</div>
                            <div className="value">{anleggsprojeksjonsflate.medium}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Anleggsprojeksjonsflate)